<main class="d-flex-row flex-wrap main">
  <div class="form-container">
    <div class="d-flex-column">
      <div class="d-flex-row align-center">
        <i class="step-card-icon text-icon-size step-completed">1</i>
        <h1 class="form-title-main-text">Informe seus dados</h1>
      </div>
      <div class="d-flex-row align-center">
        <p class="form-title-secondary-text">Já possui cadastro? </p>
        <a class="form-title-secondary-text-url" (click)="onLinkClick()">Clique aqui</a>
      </div>
    </div>

    <form [formGroup]="this.formControlService.identificationDisconnectedSaleForm" class="form"
      (ngSubmit)="this.register()">
      <pme-alert type="error" title="Atenção" *ngFor="let error of this.onSubmitIdentificationErrors">{{ error
        }}</pme-alert>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-control right-form-spacing">
          <mat-label>E-mail Principal</mat-label>
          <input matInput type="email" id="email" name="email" required autocomplete="email" maxlength="60"
            formControlName="email" (input)="checkEmailsMatch()" (blur)="onBlurField('email')" />
          <mat-error>{{ formControlService.getIdentificationErrors().email }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-control" (mouseover)="show = true" (mouseout)="show = false">
          <mat-label>Confirme o e-mail principal</mat-label>
          <input matInput type="email" required autocomplete="email" maxlength="60" formControlName="emailConfirm"
            (input)="checkEmailsMatch()" (blur)="onBlurField('emailConfirm')" />
          <div class="custom-tooltip" [ngClass]="{ 'tooltip-visible': show }">
            Coloque o e-mail que você tem acesso para definir a senha e confirmar o seu cadastro.
            <span class="tooltip-arrow"></span>
          </div>
          <mat-error>{{ formControlService.getIdentificationErrors().emailConfirm }}</mat-error>
        </mat-form-field>
      </div>
<div *ngIf="!hideIdentification">
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-control right-form-spacing">
      <mat-label>CNPJ da empresa</mat-label>
      <input matInput type="tel" inputmode="numeric" id="cnpj" name="cnpj"
        placeholder="00.000.000/0000-00" #cnpj formControlName="cnpj" [mask]="masks.cnpj"
        (blur)="onBlurField('cnpj')" [required]="!hideIdentification" />
      <mat-error>{{ formControlService.getIdentificationErrors().cnpj }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-control">
      <mat-label>CPF</mat-label>
      <input matInput type="tel" inputmode="numeric" id="cpf" name="cpf"
        placeholder="000.000.000-00" #cpf formControlName="cpf" [mask]="masks.cpf"
        (blur)="onBlurField('cpf')" [required]="!hideIdentification" />
      <mat-error>{{ formControlService.getIdentificationErrors().cpf }}</mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-control">
      <mat-label>Nome completo</mat-label>
      <input matInput type="text" id="name" name="name" autocomplete="name"
        #name formControlName="name" (blur)="onBlurField('name')" [required]="!hideIdentification" />
      <mat-error>{{ formControlService.getIdentificationErrors().name }}</mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-control right-form-spacing">
      <mat-label>Data de nascimento</mat-label>
      <input matInput type="text" id="birthDate" name="birthDate" placeholder="DD/MM/AAAA" autocomplete="bday"
        #birthDate [mask]="masks.date" formControlName="birthDate"
        (blur)="onBlurField('birthDate')" [required]="!hideIdentification" />
      <mat-error>{{ formControlService.getIdentificationErrors().birthDate }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-control">
      <mat-label>Telefone celular</mat-label>
      <input matInput type="tel" inputmode="numeric" name="mobile" id="phone"
        placeholder="(00) 90000-0000" autocomplete="tel" #cellphone [mask]="masks.mobilePhoneNumber"
        formControlName="phone" (blur)="onBlurField('phone')" [required]="!hideIdentification" />
      <mat-error>{{ formControlService.getIdentificationErrors().cellphone }}</mat-error>
    </mat-form-field>
  </div>
</div>
      <pme-alert *ngIf="successIdentificationMessage" type="success" title="Encontramos seu cadastro!">
        {{ successIdentificationMessage }}
      </pme-alert>
      <div class="spacing-margin display-utils-row display-utils-center-center display-utils-gap-20">
        <button class="pme-btn-lg btn-success" type="submit" [disabled]="!canSubmit()" [ngClass]="{
                'btn-success': canSubmit(),
                'btn-disable': !canSubmit()
              }">
          <div class="display-utils-row display-utils-center-center display-utils-gap-8">
            <mat-spinner *ngIf="this.submitting" diameter="20" aria-label="Carregando"></mat-spinner>
            <div>Continuar</div>
          </div>
        </button>
      </div>
    </form>
  </div>

  <aside class="product-info-card">
    <pme-disconnected-sale-product [productFamily]="this.productFamily" [productName]="this.productName"
      [valuePerMonth]="this.valuePerMonth" [totalValue]="this.totalValue" [productImg]="this.productImg"
      [installments]="this.installments" [firstStep]="true" [productValue]="this.productValue"
      [discountedValue]="this.discountedValue"></pme-disconnected-sale-product>
  </aside>
</main>